import { cx } from "@jugl-web/utils";
import { FC, ReactNode } from "react";

interface WidgetContainerProps {
  children: ReactNode;
  className?: string;
}

export const WidgetContainer: FC<WidgetContainerProps> = ({
  children,
  className,
}) => (
  <div
    className={cx(
      "min-h-0 w-full overflow-hidden rounded-xl border border-solid border-grey-300 bg-white p-5",
      className
    )}
  >
    {children}
  </div>
);
